import {
  Banknote,
  BarChart3,
  Book,
  BookMarked,
  BookOpen,
  Calendar,
  CalendarCheck,
  CalendarClock,
  CalendarX,
  ClipboardCheck,
  ClipboardList,
  Cog,
  DoorClosed,
  DoorOpen,
  FileEdit, FileText,
  Gift, Package,
  Receipt,
  Settings,
  Shield,
  Stethoscope,
  Store,
  Syringe,
  TestTube,
  Ticket,
  TrendingUp,
  User,
  UserCog,
  Users,
  Wand2,
  DollarSign
} from "lucide-react";

type NavigationElementItem = {
  title: string;
  url: string;
  icon: React.ReactNode | React.ReactNode[] | null;
}
type NavigationElementGroup = {
  title: string;
  items: NavigationElementItem[];
  collapsible?: boolean;
  defaultOpen?: boolean;
}

export const navigationElementsAdmin: NavigationElementGroup[] = [
  {
    title: "Termine",
    collapsible: false,
    items: [
      { title: "Termine", url: "/appointments-calendar", icon: <Calendar /> },
      { title: "Board", url: "/appointments-board", icon: <ClipboardList /> },
      { title: "Schichtplanung", url: "/shift-planning", icon: <CalendarClock /> },
    ],
  },
  {
    title: "Kunden",
    collapsible: false,
    items: [
      { title: "Kunden", url: "/customers", icon: <Users /> },
      { title: "Bluttests", url: "/blood-tests", icon: <TestTube /> },
    ],
  },
  {
    title: "Finanzen",
    collapsible: true,
    defaultOpen: true,
    items: [
      { title: "Aufträge", url: "/billing-drafts", icon: <Receipt /> },
      { title: "Rechnungen", url: "/invoices", icon: <FileText /> },
      { title: "Zahlungen", url: "/payments", icon: <DollarSign /> },
      { title: "Bundles", url: "/bundles", icon: <Package /> },
      { title: "Wertgutscheine", url: "/gift-cards", icon: <Gift /> },
      { title: "Ausfallentschädigung", url: "/cancellation-fees", icon: <CalendarX /> },
      { title: "Kassen", url: "/cash-registers", icon: <Banknote /> },
    ],
  },
  {
    title: "Katalog",
    collapsible: true,
    defaultOpen: false,
    items: [
      { title: "Leistungskategorien", url: "/product-categories", icon: <BookMarked /> },
      { title: "Leistungen", url: "/treatments", icon: <BookOpen /> },
      { title: "Leistungen (GOÄ)", url: "/treatments-goa", icon: <BookOpen /> },
      { title: "Materials", url: "/materials", icon: <Syringe /> },
      { title: "Produkte", url: "/products", icon: <Package /> },
      { title: "Gutschein-Vorlagen", url: "/gift-card-templates", icon: <Gift /> },
    ],
  },
  {
    title: "Praxisverwaltung",
    collapsible: true,
    defaultOpen: false,
    items: [
      { title: "Filialen", url: "/stores", icon: <Store /> },
      { title: "Behandlerkategorien", url: "/practitioner-categories", icon: <UserCog /> },
      { title: "Behandler", url: "/practitioners", icon: <Stethoscope /> },
      { title: "Gerätekategorien", url: "/equipment-categories", icon: <Cog /> },
      { title: "Geräte", url: "/equipment", icon: <Settings /> },
      { title: "Raumkategorien", url: "/room-categories", icon: <DoorClosed /> },
      { title: "Räume", url: "/rooms", icon: <DoorOpen /> },
      { title: "Dokumentation", url: "/medication-config", icon: <ClipboardList /> },
    ],
  },
  {
    title: "System",
    collapsible: true,
    defaultOpen: false,
    items: [
      { title: "Benutzer", url: "/users", icon: <User /> },
      { title: "CMS", url: "/cms", icon: <FileEdit /> },
      { title: "Warteliste", url: "/waitlist-submissions", icon: <Ticket /> },
      { title: "Berechtigungen", url: "/permissions", icon: <Shield /> },
      { title: "Logs", url: "/logs", icon: <Book /> },
      { title: "Behandler Dashboards", url: "/practitioner-dashboard", icon: <BarChart3 /> },
      { title: "Analytics", url: "/analytics", icon: <TrendingUp /> },
      { title: "Buchbarkeits-Check", url: "/bookability-check", icon: <CalendarCheck /> },
      { title: "Bug Report Board", url: "/feature-requests", icon: <Wand2 /> },
      { title: "QM", url: "/qm", icon: <ClipboardCheck /> },
    ],
  },
];

export const navigationElementsUser: NavigationElementGroup[] = [
  {
    title: "Termine",
    collapsible: false,
    items: [
      { title: "Termine", url: "/appointments-calendar", icon: <Calendar /> },
      { title: "Board", url: "/appointments-board", icon: <ClipboardList /> },
      { title: "Schichtplanung", url: "/shift-planning", icon: <CalendarClock /> },
    ],
  },
  {
    title: "Kunden",
    collapsible: false,
    items: [
      { title: "Kunden", url: "/customers", icon: <Users /> },
      { title: "Bluttests", url: "/blood-tests", icon: <TestTube /> },
    ],
  },
  {
    title: "Finanzen",
    collapsible: true,
    defaultOpen: true,
    items: [
      { title: "Aufträge", url: "/billing-drafts", icon: <Receipt /> },
      { title: "Rechnungen", url: "/invoices", icon: <FileText /> },
      { title: "Zahlungen", url: "/payments", icon: <DollarSign /> },
      { title: "Bundles", url: "/bundles", icon: <Package /> },
      { title: "Wertgutscheine", url: "/gift-cards", icon: <Gift /> },
      { title: "Kassen", url: "/cash-registers", icon: <Banknote /> },
    ],
  },
  {
    title: "Katalog",
    collapsible: true,
    defaultOpen: false,
    items: [
      { title: "Produkte", url: "/products", icon: <Package /> },
    ],
  },
  {
    title: "Verwaltung",
    collapsible: true,
    defaultOpen: false,
    items: [
      { title: "Warteliste", url: "/waitlist-submissions", icon: <Ticket /> },
      { title: "Behandler Dashboards", url: "/practitioner-dashboard", icon: <BarChart3 /> },
      { title: "Logs", url: "/logs", icon: <Book /> },
      { title: "Bug Report Board", url: "/feature-requests", icon: <Wand2 /> },
    ],
  },
];

export default { navigationElementsUser, navigationElementsAdmin };